export function dateToMonthDayYearString(date: Date) {
  const month = date.getMonth() + 1;
  const monthString = month < 10 ? `0${month}` : month.toString();

  const day = date.getDate();
  const dayString = day < 10 ? `0${day}` : day.toString();

  const year = date.getFullYear();

  return `${monthString}/${dayString}/${year}`;
}
